import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import LoginPage from "./pages/Login/LoginPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import ModulePage from "./pages/Module/ModulePage";
import OrderDetailPage from "./pages/OrderDetail/OrderDetailPage";
import MerchantDetailPage from "./pages/MerchantDetail/MerchantDetailPage";
import OutletDetailPage from "./pages/OutletDetail/OutletDetailPage";
import MerchantOwnerAccessPage from "./pages/Merchants/MerchantOwnerAccessPage";
import MerchantOwnerFormPage from "./pages/Merchants/MerchantOwnerFormPage";
import ProfilePage from "./pages/Profile/ProfilePage";
import AdministratorFormPage from "./pages/AdministratorForm/AdministratorFormPage";
import AdministratorsPage from "./pages/Administrators/AdministratorsPage";
import AuditTrailPage from "./pages/AuditTrail/AuditTrailPage";
import ProtectedRoute from "./components/ProtectedRoute";
import PermissionRoute from "./components/PermissionRoute";
import AppLayout from "./components/AppLayout/AppLayout";
import { isAdminAuthenticated } from "./api/adminAuthApi";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          path="/"
          element={
            <ProtectedRoute isAuthenticated={isAdminAuthenticated()}>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="orders" element={<PermissionRoute permission="orders"><ModulePage type="orders" /></PermissionRoute>} />
          <Route path="orders/:orderId" element={<PermissionRoute permission="orders"><OrderDetailPage /></PermissionRoute>} />
          <Route path="cancellations" element={<PermissionRoute permission="orders"><ModulePage type="cancellations" /></PermissionRoute>} />
          <Route path="merchants" element={<PermissionRoute permission="merchants"><ModulePage type="merchants" /></PermissionRoute>} />
          <Route path="merchants/create" element={<PermissionRoute permission="merchants"><MerchantDetailPage mode="create" /></PermissionRoute>} />
          <Route path="merchants/:merchantId" element={<PermissionRoute permission="merchants"><MerchantDetailPage /></PermissionRoute>} />
          <Route path="merchants/:merchantId/edit" element={<PermissionRoute permission="merchants"><MerchantDetailPage mode="edit" /></PermissionRoute>} />
          <Route path="merchants/:merchantId/outlets/create" element={<PermissionRoute permission="merchants"><OutletDetailPage mode="create" /></PermissionRoute>} />
          <Route path="merchants/:merchantId/outlets/:outletId" element={<PermissionRoute permission="merchants"><OutletDetailPage /></PermissionRoute>} />
          <Route path="merchant-owners" element={<PermissionRoute permission="merchants"><MerchantOwnerAccessPage /></PermissionRoute>} />
          <Route path="merchant-owners/create" element={<PermissionRoute permission="merchants"><MerchantOwnerFormPage /></PermissionRoute>} />
          <Route path="merchant-owners/:ownerId/edit" element={<PermissionRoute permission="merchants"><MerchantOwnerFormPage mode="edit" /></PermissionRoute>} />
          <Route path="administrators" element={<PermissionRoute permission="administrators"><AdministratorsPage /></PermissionRoute>} />
          <Route path="administrators/create" element={<PermissionRoute permission="administrators"><AdministratorFormPage mode="create" /></PermissionRoute>} />
          <Route path="administrators/:adminId/edit" element={<PermissionRoute permission="administrators"><AdministratorFormPage mode="edit" /></PermissionRoute>} />
          <Route path="settings" element={<PermissionRoute permission="settings"><ModulePage type="settings" /></PermissionRoute>} />
          <Route path="audit-trail" element={<PermissionRoute permission="administrators"><AuditTrailPage /></PermissionRoute>} />
          <Route path="reports" element={<PermissionRoute permission="reports"><ModulePage type="reports" /></PermissionRoute>} />
          <Route path="profile" element={<ProfilePage />} />
        </Route>

        <Route
          path="*"
          element={isAdminAuthenticated() ? <Navigate to="/" /> : <Navigate to="/login" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
